import { render, staticRenderFns } from "./SocialList.vue?vue&type=template&id=59b63dd9&"
import script from "./SocialList.vue?vue&type=script&lang=js&"
export * from "./SocialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports